import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchProductionOrderById } from '../api/fetch-production-order.api';
import type { ProductionOrder } from '../utils/types';

export const getProductionOrderById = createAsyncThunk<
  ProductionOrder,
  string,
  { rejectValue: string }
>(
  'ProductionReporting/getProductionOrderById',
  async (productionOrderId, thunkAPI) => {
    try {
      return await fetchProductionOrderById({ productionOrderId });
    } catch (error: unknown) {
      return thunkAPI.rejectWithValue(
        typeof error === 'object' &&
          error !== null &&
          'message' in error &&
          typeof error.message === 'string' &&
          error.message
          ? error.message
          : 'Failed to fetch production order by ID'
      );
    }
  }
);
